import * as React from 'react';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import FrontPageCmsContent from 'bundles/front-page/components/FrontPageCmsContent';
import { FrontPageDataProvider } from 'bundles/front-page/components/FrontPageDataProvider';
import type { FrontPageDataState } from 'bundles/front-page/components/FrontPageDataProvider';
import FrontPageGoogleSchemaMarkup from 'bundles/front-page/components/FrontPageGoogleSchemaMarkup';
import type { FrontPageContentProps as Props } from 'bundles/front-page/types';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import LoggedOutPageHeader from 'bundles/page-header/components/optimized/LoggedOutPageHeader';
import { CourseraMetatags } from 'bundles/seo';

const LoadableSurveyModal = createLoadableComponent(
  () => import('bundles/growth-upsell/user-intent-survey/SurveyModal')
);
type ConditionalFrontPageContentProps = FrontPageDataState & {
  isUsRegion: boolean;
  countryCode?: string;
};
export const ConditionalFrontPageCmsContent = ({
  pageContent,
  isUsRegion,
  ...otherProps
}: ConditionalFrontPageContentProps) => {
  return pageContent ? (
    <FrontPageCmsContent {...otherProps} key="lohp-cms-content" pageContent={pageContent} isUsRegion={isUsRegion} />
  ) : null;
};

const FrontPage = (props: Props) => {
  const { countryCode } = props;
  const isUsRegion = countryCode === 'us';

  return (
    <React.Fragment>
      <LoggedOutPageHeader isFrontPage />
      <FrontPageDataProvider {...props}>
        {({ pageContent, ...otherProps }: FrontPageDataState) => (
          <ConditionalFrontPageCmsContent
            pageContent={pageContent}
            isUsRegion={isUsRegion}
            countryCode={countryCode}
            {...otherProps}
          />
        )}
      </FrontPageDataProvider>
      <LoadableSurveyModal
        pageType="homePage"
        epicParam="tvInterceptSurveyLate2019Homepage"
        cookieName="post-tv-survey-dec-2019"
        showForCountryCode="US"
      />
      <LoadableSurveyModal
        cookieName="post-tv-survey-gb-apr-2020"
        pageType="homePage"
        epicParam="tvInterceptSurveyApr2020GbHomepage"
        showForCountryCode="GB"
      />
      <LoadableSurveyModal
        pageType="homePage"
        epicParam="tvInterceptSurveySep2021InHomepage"
        cookieName="post-tv-survey-in-sep-2021"
        showForCountryCode="IN"
      />
      <PageFooter />
      <CourseraMetatags metaNameAndProperties={{ disableCourseraSuffix: true }} />

      <FrontPageGoogleSchemaMarkup />
    </React.Fragment>
  );
};

export default FrontPage;
